"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePasswordForm = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const Button_1 = require("../../Button");
const Field_1 = require("../../Form/Field");
const ValidationErrors_1 = require("../../ValidationErrors");
const customErrorsMap_1 = __importDefault(require("./customErrorsMap"));
require("./index.scss");
const className = 'update-password-form';
class UpdatePasswordForm extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            formData: this.props.formData,
            focusFieldName: this.props.focusFieldName,
        };
        this.handleFieldChange = (fieldName, event) => {
            const { value } = event.target;
            const updatedData = {
                ...this.state.formData,
                ...{
                    [fieldName]: value,
                },
            };
            this.props.onChange({
                fieldName,
                formData: updatedData,
            });
            this.setState({
                formData: updatedData,
                focusFieldName: fieldName,
            });
        };
        this.handleSubmit = (event) => {
            event.preventDefault();
            this.props.onSubmit(this.state.formData);
        };
        this.setFocus = () => {
            var _a, _b;
            if (this.state.focusFieldName !== undefined) {
                (_b = (_a = this.fieldRefs[this.state.focusFieldName].current).focus) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
        };
        this.getFormError = (fieldName) => {
            var _a;
            const customMapIfExists = (_a = customErrorsMap_1.default[fieldName]) !== null && _a !== void 0 ? _a : {};
            return (0, ValidationErrors_1.getFormError)(this.props.formErrors, fieldName, customMapIfExists);
        };
        this.fieldRefs = {
            password: react_1.default.createRef(),
            passwordConfirm: react_1.default.createRef(),
        };
    }
    componentDidMount() {
        this.setFocus();
    }
    componentDidUpdate() {
        this.setFocus();
    }
    render() {
        const classNames = (0, classFunctions_1.getClassNames)(className, this.props.modificators);
        const { formData } = this.state;
        const { isSubmitButtonDisabled, } = this.props;
        const { password, passwordConfirm, } = formData;
        return (react_1.default.createElement("form", { className: classNames, onSubmit: this.handleSubmit },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement("h3", { className: `${className}__title` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/UpdatePasswordForm/Title:text', defaultMessage: 'Reset your password' })),
                react_1.default.createElement("div", { className: `${className}__field` },
                    react_1.default.createElement(Field_1.FormField, { autoComplete: 'new-password', type: 'password', ref: this.fieldRefs.password, value: password, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/UpdatePasswordForm/Password:label', defaultMessage: 'Password' }), error: this.getFormError('password'), onChange: event => this.handleFieldChange('password', event) })),
                react_1.default.createElement("div", { className: `${className}__field` },
                    react_1.default.createElement(Field_1.FormField, { autoComplete: 'new-password', type: 'password', ref: this.fieldRefs.passwordConfirm, value: passwordConfirm, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/UpdatePasswordForm/passwordConfirm:label', defaultMessage: 'Confirm password' }), error: this.getFormError('passwordConfirm'), onChange: event => this.handleFieldChange('passwordConfirm', event) })),
                react_1.default.createElement("div", { className: `${className}__buttons` },
                    react_1.default.createElement(Button_1.Button, { type: 'submit', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Auth/UpdatePasswordForm/Submit:label', defaultMessage: 'Reset password' }), disabled: isSubmitButtonDisabled })))));
    }
}
exports.UpdatePasswordForm = UpdatePasswordForm;
UpdatePasswordForm.defaultProps = {
    formData: {
        password: '',
        passwordConfirm: '',
    },
    formErrors: {},
    isSubmitButtonDisabled: false,
    focusFieldName: undefined,
    onChange: () => {
    },
    onSubmit: () => {
    },
};
//# sourceMappingURL=index.js.map